/**
 * @generated SignedSource<<6707c0e8d8dc9ac1245492f0aa97fd03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Tile_kpiTileGraphBar$data = {
  readonly parts: number;
  readonly " $fragmentType": "Tile_kpiTileGraphBar";
};
export type Tile_kpiTileGraphBar$key = {
  readonly " $data"?: Tile_kpiTileGraphBar$data;
  readonly " $fragmentSpreads": FragmentRefs<"Tile_kpiTileGraphBar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tile_kpiTileGraphBar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parts",
      "storageKey": null
    }
  ],
  "type": "WidgetKPITileGraphBar",
  "abstractKey": null
};

(node as any).hash = "f63475e8428e4163ab1eb16da5877aae";

export default node;
